<template>
  <component :is="dialogMode ? 'div' : 'page'" class="agent-level">
    <div class="page-content" :class="{ 'page-content--dialog': dialogMode }">
      <!-- 操作区 -->
      <div class="actions">
        <el-button type="primary" size="mini" @click="handleAdd">新增代理等级</el-button>
      </div>
      <el-table :data="tableData" border stripe size="small" fit highlight-current-row style="width: 100%">
        <el-table-column :resizable="false" prop="agent_level" label="代理等级" width="100" align="center">
          <template slot-scope="scope">
            {{ `LV${scope.row.agent_level}` }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          prop="level_name"
          label="等级名称"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          :resizable="false"
          prop="need_share_num"
          label="新增直属下级(人数)"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.need_share_num | formatShareNum }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          prop="upgrade_need_gold"
          label="晋级条件(需再获得佣金)"
          min-width="160"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.upgrade_need_gold | centsToYuan }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          prop="share_one_rate"
          label="直属代理佣金比例"
          min-width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.share_one_rate | formatRate }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          prop="share_two_rate"
          label="二级代理佣金比例"
          min-width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.share_two_rate | formatRate }}
          </template>
        </el-table-column>
        <el-table-column :resizable="false" fixed="right" prop="count" label="代理数量" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewAgents(scope.row)">{{ scope.row.count }}</el-button>
          </template>
        </el-table-column>
        <el-table-column :resizable="false" fixed="right" label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      append-to-body
      class="page-dialog center-dialog"
      :visible="addLevelDialogVisible"
      :title="editId ? '编辑代理等级' : '新增代理等级'"
      width="600px"
      @close="addLevelDialogVisible = false"
    >
      <el-form
        ref="addLevelFormRef"
        class="add-level-form"
        :model="addLevelForm"
        :rules="addFormRules"
        label-width="180px"
      >
        <el-form-item label="代理等级" prop="agent_level">
          <el-input v-model="addLevelForm.agent_level" style="width: 200px" disabled></el-input>
        </el-form-item>
        <el-form-item label="等级名称" prop="level_name">
          <el-input v-model="addLevelForm.level_name" style="width: 200px" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="新增直属下级(人数)" prop="need_share_num">
          <!-- <template slot="label">
            <div class="label-container">
              <div class="label-text">新增直属下级</div>
              <div class="label-text-sub">(人数)</div>
            </div>
          </template> -->
          <el-input-number
            v-model="addLevelForm.need_share_num"
            :controls="false"
            :step="1"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="晋级条件(需再获得佣金)" prop="upgrade_need_gold">
          <!-- <template slot="label">
            <div class="label-container">
              <div class="label-text">晋级条件</div>
              <div class="label-text-sub">(需再获得佣金)</div>
            </div>
          </template> -->
          <el-input-number
            v-model="addLevelForm.upgrade_need_gold"
            :controls="false"
            :step="1"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <div class="rate-item">
          <el-form-item label="直属代理佣金比例" prop="share_one_rate">
            <el-input-number
              v-model="addLevelForm.share_one_rate"
              :controls="false"
              :step="0.01"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <div class="suffix">%</div>
        </div>
        <div class="rate-item">
          <el-form-item label="二级代理佣金比例" prop="share_two_rate">
            <el-input-number
              v-model="addLevelForm.share_two_rate"
              :controls="false"
              :step="0.01"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <div class="suffix">%</div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addLevelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddLevelSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 代理数量列表弹窗 -->
    <AgentCountListDialog
      :visible.sync="agentCountListDialogVisible"
      :level="agent_level"
      :title="agentCountListDialogTitle"
      @closed="handleAgentCountListClosed"
    />
  </component>
</template>

<script>
import { AgentApi } from '@/api/agent'
import AgentCountListDialog from './components/agent-count-list.dialog.vue'
import { centsToYuan, centsToYuanNumber, yuanToCents } from '@/utils/amount'

export default {
  name: 'AgentLevel',
  components: {
    AgentCountListDialog,
  },
  props: {
    dialogMode: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatShareNum(value) {
      if (value == null) {
        return '--'
      }

      return `≥${value}`
    },
    // formatGold(value) {
    //   if (value == null) {
    //     return '--'
    //   }

    //   return `≥${value.toFixed(2)}`
    // },
    formatRate(value) {
      if (value == null) {
        return '--'
      }

      return `${value.toFixed(2)}%`
    },
  },
  data() {
    return {
      tableData: [],
      addLevelDialogVisible: false,
      editId: null,
      addLevelForm: {
        agent_level: null,
        level_name: '',
        need_share_num: null,
        share_one_rate: null,
        share_two_rate: null,
        upgrade_need_gold: null,
      },
      addFormRules: {
        level_name: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        need_share_num: [{ required: true, message: '请输入新增直属下级人数', trigger: 'blur' }],
        share_one_rate: [{ required: true, message: '请输入直属代理佣金比例', trigger: 'blur' }],
        share_two_rate: [{ required: true, message: '请输入二级代理佣金比例', trigger: 'blur' }],
        upgrade_need_gold: [{ required: true, message: '请输入晋级条件（需再获得佣金）', trigger: 'blur' }],
      },

      // 代理数量列表弹窗
      agentCountListDialogVisible: false,
      agentCountListDialogTitle: '代理数量列表',
      agent_level: null,
      isflag: false,
    }
  },
  mounted() {
    this.isflag = false
    this.getAgentLevelList()
  },
  methods: {
    async getAgentLevelList() {
      const res = await AgentApi.getAgentLevelList()
      this.tableData = res.data.list || []
    },

    handleViewAgents(data) {
      this.agent_level = data.agent_level
      this.agentCountListDialogTitle = `${data.level_name}数量`
      this.agentCountListDialogVisible = true
    },
    handleAdd() {
      this.addLevelForm = {
        agent_level: this.tableData.length + 1,
        level_name: '',
      }
      this.addLevelDialogVisible = true
      this.editId = null
    },
    async addAgentLevel(data) {
      try {
        if (this.isflag) {
          return
        }
        this.isflag = true
        const res = await AgentApi.addAgentLevel(data)
        this.isflag = false
        if (res.code === 0) {
          this.$message.success('新增成功')
          this.addLevelDialogVisible = false
          this.getAgentLevelList()
        }
      } catch (error) {
        this.isflag = false
        this.$message.error('新增失败：' + error.message)
      }
    },
    async editAgentLevel(data) {
      try {
        if (this.isflag) {
          return
        }
        this.isflag = true
        const res = await AgentApi.editAgentLevel(data)
        this.isflag = false
        if (res.code === 0) {
          this.$message.success('编辑成功')
          this.addLevelDialogVisible = false
          this.getAgentLevelList()
        }
      } catch (error) {
        this.isflag = false
        this.$message.error('编辑失败：' + error.message)
      }
    },
    handleAddLevelSubmit() {
      this.$refs.addLevelFormRef.validate(valid => {
        if (!valid) {
          this.isflag = false
          return
        }
        if (this.editId) {
          this.editAgentLevel({
            ...this.addLevelForm,
            id: this.editId,
            upgrade_need_gold: yuanToCents(this.addLevelForm.upgrade_need_gold),
          })
        } else {
          this.addAgentLevel({
            ...this.addLevelForm,
            upgrade_need_gold: yuanToCents(this.addLevelForm.upgrade_need_gold),
          })
        }
      })
    },
    handleEdit(data) {
      try {
        this.addLevelForm = {
          agent_level: data.agent_level,
          level_name: data.level_name,
          need_share_num: data.need_share_num,
          share_one_rate: data.share_one_rate,
          share_two_rate: data.share_two_rate,
          upgrade_need_gold: centsToYuanNumber(data.upgrade_need_gold),
        }
        this.editId = data.id
        this.addLevelDialogVisible = true
      } catch (error) {
        this.$message.error('编辑失败：' + error.message)
      }
    },
    handleAgentCountListClosed() {
      this.agent_level = null
    },
  },
}
</script>

<style lang="scss" scoped>
.agent-level {
  height: 100%;
}

.actions {
  margin-bottom: 16px;
}

.page-content {
  height: 100%;
}

.page-content--dialog {
  padding: 0;
}
.label-text {
  line-height: 1.5;
  font-weight: 600;
  text-align: right;
}
.label-text-sub {
  line-height: 1;
  text-align: right;
}
.label-container {
  display: inline-block;
}

.add-level-form {
  ::v-deep {
    .el-input-number .el-input__inner {
      text-align: left;
    }
  }
}

.rate-item {
  position: relative;
}

.suffix {
  position: absolute;
  left: 388px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
